import type Actor from "../models/Actor";
import type Channel from "../models/Channel";
import { ChannelType, channelTypeInfo } from "../models/ChannelType";
import type Consumer from "../models/Consumer";
import { getSignalTypeBundle } from "../models/SignalBundles";
import type SignalType from "../models/SignalType";
import SignalTypes from "../models/SignalTypes";
import AddressGeneratorUtils from "./AddressGeneratorUtils";
import GroupAddress from "../models/GroupAdress";


export function linkActors() {
  state.cabinets.forEach((cabinet) => {
    cabinet.actors.forEach((actor) => {
      linkActor(actor);
    });
  });
}

//
// Handle Link from Jalousie to LOCK. Returns changed flag and consumerGroupAddress to use.
//
function linkActorLockSignal(consumer: Consumer, knxChannel: Channel): boolean {
  let changed = false;
  let consumerGroupAddress = consumer.getGroupAddressByType(SignalTypes.Lock);

  if (channelTypeInfo(consumer.channelType).isRollo) {
    const connectedLockConsumers = consumer.getConnectedLockConsumers();
    const groupAddressFromLocks1: Array<GroupAddress | undefined> = connectedLockConsumers.map(c => c.getGroupAddressByType(SignalTypes.Lock));
    const groupAddressFromLocks = groupAddressFromLocks1.filter((ga): ga is GroupAddress => ga !== undefined);
    const consumerLockSignal = consumer.getSignalByType(SignalTypes.Lock);

    if (consumerLockSignal) {
      for (const groupAddressFromLock of groupAddressFromLocks) {
        //
        // Set or Update LockGroupAddress für JalousieChannel
        // to the groupAddress from the Lock
        //
        if (consumerLockSignal.addGroupAddress(groupAddressFromLock)) {
          groupAddressFromLock.addSignalBackpointer(consumerLockSignal);
          consumerLockSignal.raiseOnChange(`@addGroupAddress ${groupAddressFromLock.address}`);
          changed = true;
        }
        consumerGroupAddress = groupAddressFromLock;

        const changed1 = attachGroupAddressToKnxSignalsByType(knxChannel, SignalTypes.Lock, groupAddressFromLock);
        changed = changed1 || changed;

      }
    }
  }
  return changed;
}

//
// Assign Consumer Signals/Groupadresses for one channel.
// Returns true if any GroupAddress assignment changed.
//
function linkActorSignal(signalType: SignalType, knxChannel: Channel, consumer: Consumer): boolean {
  let changed = false;

  let isGlobalGroupAdress = signalType.globalGroupAdress != undefined;

  if (signalType.name == SignalTypes.OperationMode.name ||
    signalType.name == SignalTypes.OperationMode_Status.name
  ) {
    //
    // für HAVC OperationMode gibt es 2 Möglichkeiten
    // Irgend  Button steuert den globalen HVAC OperationMode "31/1/20"
    //    das ist der Fall wenn der Button mit keiner Heating Funtion verbunden ist
    //
    //
    // Der Button "für" diesen Kanal steuert eine "private" OperationMode GroupAdress
    //

    //
    // Für den Actor binden wir somit den "privaten" OperationMode" hier IMMER.
    // der globale wird dann in LinkEnvironmentSignals() gebunden
    //

    isGlobalGroupAdress = false
  }


  if (!isGlobalGroupAdress) {
    let consumerGroupAddress = consumer.getGroupAddressByType(signalType);

    if (signalType.name == SignalTypes.Lock.name) {
      const lockResult = linkActorLockSignal(consumer, knxChannel);
      changed ||= lockResult
    }

    const changed1 = attachGroupAddressToKnxSignalsByType(knxChannel, signalType, consumerGroupAddress);
    changed = changed1 || changed1;
  }

  return changed;
}



export function linkActorChannel(channel: Channel): boolean {
  let changed = false;
  channel.assetIsRequestChannel();

  // channel.removeAllGroupAdresses();

  const knxChannel = channel.knxChannel;
  const consumer = channel.getConnectedConsumer();
  if (consumer) {
    const multiplexers = consumer.getConnectedMultiplexers();

    if (knxChannel) {
      if (knxChannel.channelType != ChannelType.Unknown &&
        knxChannel.channelType != ChannelType.General &&
        knxChannel.channelType != ChannelType.Environment) {

        const signalTypes = getSignalTypeBundle(knxChannel.channelType);

        signalTypes.forEach((signalType) => {
          changed = linkActorSignal(signalType, knxChannel, consumer) || changed;
        });

        //
        // Assign Multiplexer Signals/Groupadresses
        //
        // Actors get only the "Action GroupAdresses from the Multiplexer"
        //
        multiplexers.forEach((multiplexer) => {
          signalTypes.forEach((signalType) => {
            if (!signalType.isStatus) {
              const groupAddress = multiplexer.getGroupAddressByType(signalType);

              const knxSignal = knxChannel.getSignalByType(signalType);
              if (knxSignal && groupAddress) {
                if (AddressGeneratorUtils.attachGroupAddressToSignal(knxSignal, groupAddress)) {
                  changed = true;
                }
              }
            }
          });
        });
      }
    }
  }

  return changed;
}

//
// returns true if there is any change in GroupAdress-Assignment
//
export function linkActor(actor: Actor): boolean {
  let changed = false;


  if (actor.template == undefined) {
    //
    // actor has not a product assigned yet
    // so we cant create any group address assignments
    //
    return false;
  }

  actor.channels.forEach((channel) => {
    const changed1 = linkActorChannel(channel);
    changed = changed || changed1;
  });

  return changed;
}






//
// Attach groupAddress to all KNX signals of the given type on knxChannel. Returns true if any assignment changed.
//
function attachGroupAddressToKnxSignalsByType(
  knxChannel: Channel,
  signalType: SignalType,
  groupAddress: GroupAddress | undefined
): boolean {
  let changed = false;
  const knxSignals = knxChannel.getSignalsByType(signalType);
  for (const knxSignal of knxSignals) {
    if (knxSignal && groupAddress) {
      if (AddressGeneratorUtils.attachGroupAddressToSignal(knxSignal, groupAddress)) {
        groupAddress.addSignalBackpointer(knxSignal);
        changed = true;
      }
    }
  }
  return changed;
}
